import axios from 'axios';
import store from '../index';

const state = {
	orders: [],
	order: [],
	index: '',
	sortBy: '',
	sortDesc: '',
	setting: {},
	enableAgents: false,
	// La lista e' condivisa con i carrelli abbandonati: il socket ordini non deve sovrascriverli
	listType: '',
};

const getters = {
	getOrders: state => {
		return state.orders;
	},
	getOrder: state => {
		return state.order;
	},
	getIndex: state => {
		return state.index;
	},
	getSortBy: state => {
		return state.sortBy;
	},
	getSortDesc: state => {
		return state.sortDesc;
	},
	getSetting: state => {
		return state.setting;
	},
	getEnableAgents: state => {
		return state.enableAgents;
	},
};

const actions = {
	updateFromSocket: async context => {
		//console.log(_.size(context.rootGetters['orders/getOrders']))
		if (_.size(context.rootGetters['orders/getOrders']) > 0 && context.state.listType !== 'carts') {
			//asyncFetchData(context,context.rootGetters['settings/getSetting'])
			//context.dispatch()
			context.dispatch('asyncFetchData', context.rootGetters['orders/getSetting']);
		}
		//context.commit('settings/setTextMessage', "Nuovo ordine presente", { root: true })
		//context.commit('settings/setStatusMessage', true, { root: true })
		//console.log("aggiornafrom socket",context)
	},
	newFromSocket: async context => {
		//context.commit('settings/setTextMessage', "Nuovo ordine presente", { root: true })
		//context.commit('settings/setStatusMessage', true, { root: true })
		if (_.size(context.rootGetters['orders/getOrders']) > 0 && context.state.listType !== 'carts') {
			//asyncFetchData(context,context.rootGetters['settings/getSetting'])
			//context.dispatch()
			context.dispatch('asyncFetchData', context.rootGetters['orders/getSetting']);
		}
		//console.log("aggiornafrom socket",context)
	},
	importSingleItemShopify: async (context, payload) => {
		let url = 'shopify/import-single-order';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					id: payload.id,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { errors: ['Errore inserimento'] };
				console.log('errore', err.message);
				console.log('errore', err.stackTrace);
			});
	},
	importMultiItemShopify: async (context, payload) => {
		let url = 'shopify/import-multi-order';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					start: payload.start,
					stop: payload.stop,
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				return res.data;
			})
			.catch(err => {
				return { errors: ['Errore inserimento'] };
				console.log('errore', err.message);
				console.log('errore', err.stackTrace);
			});
	},
	asyncFetchData: async (context, settings) => {
		context.commit('setListType', 'orders');
		context.commit('setSetting', settings);
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'orders';
		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: sortBy[0],
						sortDesc: sortDesc[0],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				context.commit('setOrders', res.data.data);
				return res.data.pagination;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                        //this.setLogout();
                        context.commit('profile/setLogout', {}, {root: true})
                        this.$router.push('/login')
                    }
                    throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	asyncFetchDataReturn: async (context, settings) => {
		context.commit('setSetting', settings);
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'orders';
		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: sortBy[0],
						sortDesc: sortDesc[0],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);

				return res.data.data;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                        //this.setLogout();
                        context.commit('profile/setLogout', {}, {root: true})
                        this.$router.push('/login')
                    }
                    throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	asyncFetchCartData: async (context, settings) => {
		context.commit('setListType', 'carts');
		context.commit('setSetting', settings);
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'ai/cart';
		context.commit('setSortDesc', sortDesc[0]);
		context.commit('setSortBy', sortBy[0]);
		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: sortBy[0],
						sortDesc: sortDesc[0],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				context.commit('setOrders', res.data.data);
				return res.data.pagination;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                        //this.setLogout();
                        context.commit('profile/setLogout', {}, {root: true})
                        this.$router.push('/login')
                    }
                    throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	asyncFetchReportData: async (context, settings) => {
		const { sortBy, sortDesc, page, itemsPerPage } = settings.options;
		let url = 'orders/report';

		return await axios
			.post(
				`${context.rootGetters['settings/getUrl']}${url}`,
				{
					data: {
						sortBy: sortBy[0],
						sortDesc: sortDesc[0],
						page: page,
						itemsPerPage: itemsPerPage,
						filters: settings.filters ? settings.filters : '',
						search: settings.search,
					},
				},
				{
					headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
					'Content-Type': 'application/json',
				},
			)

			.then(res => {
				//console.log(res.data.pagination);
				//context.commit('setOrders', res.data.data);
				return res;
				//resolve(res);
			})
			.catch(err => {
				console.log('errore', err);
				/*if (err.response.status === 401) {

                    //this.setLogout();
                    context.commit('profile/setLogout', {}, {root: true})
                    this.$router.push('/login')
                }
                throw Error(err.response.status + ":Posts Not Found");*/
			});
	},
	destroyData: context => {
		context.commit('setOrders', []);
		context.commit('setOrder', []);
		context.commit('setIndex', '');
		context.commit('setListType', '');
	},
	saveData: (context, payload) => {
		let url = 'auth/register';

		return new Promise((resolve, reject) => {
			context.commit('settings/setErrors', {}, { root: true });
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })

				.then(res => {
					//this.asyncFetchUsers();
					context.dispatch('asyncFetchUsers');

					resolve(res.data);
				})
				.catch(err => {
					const storeError = {
						code: err.response.status,
						statusText: err.response.statusText,
						errors: err.response.data.error,
						message: err.response.data.message,
					};
					//console.log(storeError);
					context.commit('settings/setErrors', storeError, { root: true });
					if (err.response.status === 401) {
						this.$router.push('/login');
					}
					reject(storeError);
				});
		});
	},

	createSupplierOrders: (context, payload) => {
		let url = 'orders-suppliers/create';

		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })

				.then(res => {
					if (res.data.result == 'success') {
						resolve({ result: true, all_transformed: res.data.all_transformed });
					} else {
						resolve({ result: false, message: res.data.result });
					}
				})
				.catch(err => {
					const storeError = {
						code: err.response.status,
						statusText: err.response.statusText,
						errors: err.response.data.error,
						message: err.response.data.message,
					};
					//console.log(storeError);
					context.commit('settings/setErrors', storeError, { root: true });
					if (err.response.status === 401) {
						this.$router.push('/login');
					}
					reject(storeError);
				});
		});
	},

	getOrdersReview: (context, payload) => {
		let url = 'orders/downloadReview';

		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })

				.then(res => {
					if (res.data.success == true) {
						resolve({ orders: res.data.orders });
					} else {
						resolve({ orders: [] });
					}
				})
				.catch(err => {
					const storeError = {
						code: err.response.status,
						statusText: err.response.statusText,
						errors: err.response.data.error,
						message: err.response.data.message,
					};
					//console.log(storeError);
					context.commit('settings/setErrors', storeError, { root: true });
					if (err.response.status === 401) {
						this.$router.push('/login');
					}
					reject(storeError);
				});
		});
	},

	getSupplierOrders: (context, payload) => {
		let url = 'orders-suppliers';

		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })

				.then(res => {
					if (res.data.success == true) {
						resolve({ orders: res.data.orders, void: res.data.orders_cancelled });
					} else {
						resolve({ orders: [], void: [] });
					}
				})
				.catch(err => {
					const storeError = {
						code: err.response.status,
						statusText: err.response.statusText,
						errors: err.response.data.error,
						message: err.response.data.message,
					};
					//console.log(storeError);
					context.commit('settings/setErrors', storeError, { root: true });
					if (err.response.status === 401) {
						this.$router.push('/login');
					}
					reject(storeError);
				});
		});
	},

	sendSupplierOrdersEmail: (context, payload) => {
		let url = 'orders-suppliers/send-mail-report';

		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })

				.then(res => {
					if (res.data.success) {
						resolve({ result: true });
					} else {
						resolve({ result: false });
					}
				})
				.catch(err => {
					resolve({ result: false });
				});
		});
	},

	excludeProductFromOrder: (context, payload) => {
		let url = 'orders-suppliers/exclude-product';

		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })

				.then(res => {
					if (res.data.result == 'success') {
						resolve({ result: true });
					} else {
						resolve({ result: false });
					}
				})
				.catch(err => {
					resolve({ result: false });
				});
		});
	},

	rollbackSuppliersOrder: (context, payload) => {
		let url = 'orders-suppliers/rollback';

		return new Promise((resolve, reject) => {
			axios
				.post(`${context.rootGetters['settings/getUrl']}${url}`, payload, { headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` } })

				.then(res => {
					if (res.data.result == 'success') {
						resolve({ result: true });
					} else {
						resolve({ result: false });
					}
				})
				.catch(err => {
					resolve({ result: false });
				});
		});
	},

	updateEnableAgents: (context, payload) => {
		context.commit('setEnableAgents', payload);
	},

	edit: async (context, payload) => {
		let url = `orders/${payload.id}`;

		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(result => {
				return result.data;
			})
			.catch(error => {
				console.log(error.response.data);
				console.log(error.message);
			});
	},

	getItems: async (context, payload) => {
		let url = `orders/get-data/${payload.ids}`;

		return await axios
			.get(`${context.rootGetters['settings/getUrl']}${url}`, {
				headers: { Authorization: `Bearer ${context.rootGetters['profile/getToken']}` },
				'Content-Type': 'application/json',
			})
			.then(result => {
				return result.data;
			})
			.catch(error => {
				console.log(error.response.data);
				console.log(error.message);
			});
	},
};

const mutations = {
	setOrders: (state, value) => {
		state.orders = value;
	},
	setOrder: (state, value) => {
		state.order = value;
	},
	setListType: (state, value) => {
		state.listType = value;
	},
	setIndex: (state, value) => {
		state.index = value;
	},
	setSortBy: (state, value) => {
		state.sortBy = value;
	},
	setSortDesc: (state, value) => {
		state.sortDesc = value;
	},
	setSetting: (state, value) => {
		state.setting = value;
	},

	setEnableAgents: (state, value) => {
		state.enableAgents = value;
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
